import { myAxios } from "./axios";

export function getLeadSources(payload, { page, limit }) {
  let config = {
    params: {
      page,
      limit,
      ...(payload || {}),
    },
  };
  return myAxios.get("/lead-sources", config);
}

export function getLeadSource(id) {
  return myAxios.get("/lead-sources/" + id);
}

export const addLeadSource = (data) => {
  return myAxios.post("/lead-sources/add", data);
};

export function editLeadSource(id, data) {
  return myAxios.put("/lead-sources/edit/" + id, data);
}

export function deleteLeadSource(id) {
  return myAxios.delete("/lead-sources/" + id);
}
